import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import isoLogo from "../assets/iso.png";
import msmeLogo from "../assets/msme.png";
import startupLogo from "../assets/startup.png";
import "../styles/Recognitions.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Recognitions = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="recognitions-page">

      {/* Close Button (Same Style as Gallery) */}
      <button
        className="recognitions-close-btn"
        onClick={() => navigate("/")}
      >
        ×
      </button>

      {/* HERO SECTION */}
      <div className="recognitions-hero" data-aos="fade-up">
        <h1>Corporate Recognitions & Certifications</h1>
        <p>
          Venturebiz Promotions Pvt Ltd operates with structured governance,
          regulatory compliance and internationally aligned quality standards.
          Our recognitions reinforce our commitment to operational excellence,
          transparency and sustainable business growth.
        </p>
      </div>

      {/* ISO SECTION */}
      <section className="recognition-section" data-aos="fade-right">
        <div className="recognition-image">
          <img src={isoLogo} alt="ISO 9001:2015 Certification" />
        </div>

        <div className="recognition-content">
          <h2>ISO 9001:2015 Quality Management Certification</h2>
          <div className="section-line"></div>
          <p>
            Venturebiz Promotions Pvt Ltd is certified under ISO 9001:2015,
            an internationally recognized Quality Management System standard.
          </p>
          <p>
            Through continuous monitoring, process optimization and structured
            performance evaluation, we maintain global quality benchmarks.
          </p>
          <span className="corporate-badge">
            International Standard Compliance
          </span>
        </div>
      </section>

      {/* MSME SECTION */}
      <section className="recognition-section reverse" data-aos="fade-left">
        <div className="recognition-image">
          <img src={msmeLogo} alt="MSME Registration" />
        </div>

        <div className="recognition-content">
          <h2>MSME Registration – Government of India</h2>
          <div className="section-line"></div>
          <p>
            Registered under the Ministry of Micro, Small & Medium Enterprises,
            Government of India.
          </p>
          <p>
            This enhances our credibility in the national business ecosystem.
          </p>
          <span className="corporate-badge">
            Recognized Indian Enterprise
          </span>
        </div>
      </section>

      {/* STARTUP INDIA SECTION */}
      <section className="recognition-section" data-aos="fade-right">
        <div className="recognition-image">
          <img src={startupLogo} alt="Startup India Recognition" />
        </div>

        <div className="recognition-content">
          <h2>Startup India Recognition</h2>
          <div className="section-line"></div>
          <p>
            Recognized under the Startup India initiative for innovation-driven
            business model and scalable growth.
          </p>
          <p>
            Strengthening our position in India's entrepreneurial ecosystem.
          </p>
          <span className="corporate-badge">
            Innovation Focused Organization
          </span>
        </div>
      </section>

    </div>
  );
};

export default Recognitions;
